<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <div class="vc-tigger" @click="toggleVc" v-if="count <= 10"></div>
  </div>
</template>

<script>
import vconsole from '@/utils/vconsole'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      lastClickTime: 0,
      count: 0
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    hasClass(obj, cls) {
      return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
    },
    addClass(obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += ' ' + cls
    },
    toggleClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        this.removeClass(obj, cls)
      } else {
        this.addClass(obj, cls)
      }
    },
    removeClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        obj.className = obj.className.replace(reg, ' ')
      }
    },
    toggleVc() {
      const nowTime = new Date().getTime()
      if (nowTime - this.lastClickTime < 3000) {
        this.count++
      } else {
        this.count = 0
      }
      this.lastClickTime = nowTime
      if (this.count >= 10) {
        vconsole()
      }
    }
  }
}
</script>

<style>
@import 'assets/css/icon.css';
#app {
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
html,
body,
div,
p,
h1,
h2,
h3,
h4,
h5,
ol,
ul,
li,
dl,
dt,
dd,
form,
input,
textarea,
select,
span,
table,
tr,
td,
img {
  margin: 0;
  padding: 0;
  border: 0;
}
html,
body {
  background: rgba(255, 255, 255, 0.94);
  color: rgba(122, 122, 122, 1);
  font-family: 'HYQiHei-EES', 'Hiragino Sans GB', 'Noto Sans', 'MicrosoftYahei',
    'Helvetica Neue', 'Arial';
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-font-smoothing: antialiased;
  font-size: 0.32rem;
  color: rgba(122, 122, 122, 1);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  /*height: 100%*/
}

body {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
*:focus,
*:hover {
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
:not(input, textarea) {
  -webkit-touch-callout: none;
  -webkit-user-select: element;
  user-select: element;
}
input,
textarea {
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
  -webkit-appearance: none;
}
input,
textarea {
  outline: none;
  border: none;
  border-radius: 0;
}
input::-moz-focus-inner,
input::-webkit-focus-inner,
input::focus-inner {
  border: 0;
}
textarea {
  resize: none;
}
ul,
ol,
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #333;
  outline: none;
}
a,
input {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
a:focus,
input:focus {
  outline: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

*::-webkit-scrollbar {
  display: none;
}

div#trans-tooltip,
div#tip-left-top,
div#tip-top,
div#tip-right-top,
div#tip-right,
div#tip-right-bottom,
div#tip-bottom,
div#tip-left-bottom,
div#tip-left,
div#trans-content,
div#tip-arrow-bottom,
div#tip-arrow-top {
  display: none !important;
}

.vc-tigger {
  width: 0.4rem;
  height: 0.4rem;
  position: fixed;
  left: 0;
  bottom: 0;
  opacity: 0;
  background-color: red;
  z-index: 9999;
}
</style>
